import React from 'react';
import { compose } from 'redux';
import { withScreenActions } from '../hocs/withActions';
import { withScreenData } from '../hocs/withData';

const ScreenSteps = [
  { formStep: '1', screenTitle: 'Renewal Requirements' },
  { formStep: '2', screenTitle: 'CPCS Categories' },
  { formStep: '3', screenTitle: 'Applicant Details' },
  { formStep: '4', screenTitle: 'Mailing Address' },
  { formStep: '5', screenTitle: 'Declaration' },
  { formStep: '6', screenTitle: 'Summary' },
  { formStep: '7', screenTitle: 'Evidence' },
];

const StepsMenu = ({ formScreen }) => {
  const CurrentStep = ({ formStep = '', screenTitle = '' }) => {
    const className = formStep <= formScreen ? 'filled' : '';
    return (
      <div className={`form-step ${className}`} key={`key-${formStep}`}>
        <span className="step">{formStep}</span>
        <span>{screenTitle}</span>
      </div>
    );
  };

  const StepList = () =>
    ScreenSteps.map((Step) => {
      const { formStep, screenTitle } = Step;
      return (
        <CurrentStep
          formStep={formStep}
          screenTitle={screenTitle}
          key={`key-${formStep}`}
        />
      );
    });

  return (
    <div className="steps-wrap">
      <StepList />
    </div>
  );
};

export default compose(withScreenData, withScreenActions)(StepsMenu);
